export const COMMENT_STATUS = {
  PENDING: 'pending',
  SENT: 'sent',
};
